import { SimplifiedUser } from "../Models/User";

export function persistUserSession(user: SimplifiedUser) {
  localStorage.setItem('user', JSON.stringify(user));
};

export function getUserSession(): SimplifiedUser | null {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export function clearUserSession() {
  localStorage.removeItem('user');
};
